document.addEventListener('DOMContentLoaded', () => {
  const select = document.querySelector('#Variants-{{ section.id }}');
  if (!select) return;

  const form       = document.getElementById('{{ product_form_id }}');
  const priceReg   = document.getElementById('Price-{{ section.id }}');
  const compareEl  = document.getElementById('ComparePrice-{{ section.id }}');
  const compareBox = compareEl ? compareEl.parentElement : null;

  /* ensure a hidden input exists once */
  let idInput = form.querySelector('input[name="id"]');
  if (!idInput) {
    idInput        = document.createElement('input');
    idInput.type   = 'hidden';
    idInput.name   = 'id';
    form.appendChild(idInput);
  }

  /* live update */
  const update = () => {
    const opt = select.selectedOptions[0];

    idInput.value         = opt.value;                          // send variant ID
    if (priceReg) priceReg.textContent = opt.dataset.price;     // show price

    /* compare-at price */
    if (compareBox) {
      if (opt.dataset.compare && opt.dataset.compare !== '0.00') {
        compareEl.textContent = opt.dataset.compare;
        compareBox.style.display = 'inline';
      } else {
        compareBox.style.display = 'none';
      }
    }
  };

  update();                      // run once on load
  select.addEventListener('change', update);
});
